import {Currency} from "@/models/Security/Currency";

export default {
  methods: {
    format_price(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(",", ".");
      return Currency.format(parseFloat(val))
    },
    format_price_no_cents(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(",", ".");
      return Currency.format(parseInt(val),0)
    },
    costFormat(value) {
      if(!value){ return "$0";}
      if(value === "Pendiente") {return value;}
      else {
        return "$" + this.format_price(value, 2);
      }
    },
    costFormatNoCents(value) {
      if(!value){ return "$0";}
      if(value === "Pendiente") {return value;}
      else return "$" + this.format_price(value);
    },
    prcgFormat(value, decimales = 0){
      if(value === 0){ return "0%";}
      if(!value){ return "";}
      if(value === "Pendiente"){ return value;}
      else{ return value.toFixed(decimales) + "%";}
    },
    decimalsFormat(value, decimales = 0){
      if(!value){ return 0;}
      if(value === "Pendiente"){ return 0;}
      else{ return value.toFixed(decimales);}
    },
    explicitMoneyFormat(value, decimales = 2) {
      if(value == null) return "";
      else {
        return "$" + this.format_price(value, decimales);
      }
    },
    intDigitsFormat(value){
      if(value == null) {
        return 0
      }
      else {
        return value.toFixed(0);
      }
    },
    mxnFormat(value){
      if(!value){ return "$0";}
      else {
        return "$" + this.format_price( parseInt(value), 0) + " MXN";
      }
    },
    moneyFormat(value){
      if(!value){ return "$0";}
      else {
        return "$" + this.format_price( parseInt(value), 0);
      }
    },
    decimalPercentFormat(value, decimales = 2){
      if(!value) return "0%";
      else {
        return (value * 100).toFixed(decimales) + "%";
      }
    },
    roundedFormat(value, decimales = 2){
      if(!value){ return 0; }
      else {
        let c = value.toFixed(decimales);
        let cd = Math.round(c);
        return Currency.format(cd)
      }
    },
    phoneFormat(value){
      if(!value) return value
      else {
        return '(' + value.substr(0, 2) + ') ' + value.substr(2, 4) + '-' + value.substr(6,4)
      }
    },
    phoneFormatDialCode(value){
      if(!value) return value
      else {
        return '(' + value.substr(0, 3) + ') ' + value.substr(3, 3) + '-' + value.substr(6,3)+ '-' + value.substr(9,4)
      }
    },
    numberFormat(value){
      if(!value){ return "0";}
      else {
        return this.format_price( parseInt(value), 0);
      }
    },
    moneyFormatNoCents(value){
      if(!value){ return "0";}
      else {
        return "$" + this.format_price_no_cents(parseInt(value), 0);
      }
    },
    capitalizeFirstLetter(value){
      if(!value) return value
      else {
        const arr = value.split(" ");
        for (let i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        
        } 

        return arr.join(" ");
      }
    },
    //Función para validar un RFC
    isValidRfcFormat(rfc) {
      const patternPM = "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
      const patternPF = "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
        "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
      return rfc.match(patternPM) || rfc.match(patternPF);
    },
    //Función para validar una CURP
    isValidCurpFormat(curp) {
      const pattern = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
      let isValid = curp.match(pattern);
      if (!isValid)  //Coincide con el formato general?
        return false;
      //Fuente https://consultas.curp.gob.mx/CurpSP/
      let diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";
      let lngSuma = 0.0;
      let lngDigito = 0.0;
      for (let i = 0; i < 17; i++) {
        lngSuma = lngSuma + diccionario.indexOf(isValid[1].charAt(i)) * (18 - i);
      }
      lngDigito = 10 - lngSuma % 10;
      let verifierDigit = (lngDigito != 10) ? lngDigito : 0;
      return isValid[2] == verifierDigit;
    },
    booleanFormat(value){
        return value? "Sí" : "No";
    },
    // funcion para el semaforo de las cuentas STP
    stpAccountColor(status){
      let dotClass = "dot-gray";
      switch (status) {
        case 'created':
          dotClass='dot-green';
          break;
        case 'in_process':
          dotClass='dot-yellow';
          break;
        case 'disabled':
          dotClass='dot-gray';
          break;
        case 'error':
          dotClass='dot-red';
          break;
        default:
          break;
      }
      return dotClass;
    },

    // Formato de lat y longitud
    latLongFormat(geolocalizationString){
      const latLong = {
        latitude: null,
        longitude: null
      };

      if(!geolocalizationString) return latLong;
      const parts = geolocalizationString.split(',');

      if(parts.length !== 2) return latLong;

      latLong.latitude = parts[0].replace("Lat:", "").trim();
      latLong.longitude = parts[1].replace("Long:", "").trim();

      return latLong;
    }
  }
}
